import { render, staticRenderFns } from "./PinnedChartReport.vue?vue&type=template&id=34881d71&scoped=true"
import script from "./PinnedChartReport.vue?vue&type=script&lang=ts"
export * from "./PinnedChartReport.vue?vue&type=script&lang=ts"
import style0 from "./PinnedChartReport.vue?vue&type=style&index=0&id=34881d71&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34881d71",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/build/apps/legacy/components/zeal/ZIcon/ZIcon.vue').default,ComplianceStatus: require('/build/apps/legacy/components/Reports/ComplianceStatus.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default,PinnableReportsList: require('/build/apps/legacy/components/Reports/PinnableReportsList.vue').default,DateRangePicker: require('/build/apps/legacy/components/Reports/DateRangePicker.vue').default,ReportChartLegend: require('/build/apps/legacy/components/Reports/ReportChartLegend.vue').default,ZChart: require('/build/apps/legacy/components/zeal/ZChart/ZChart.vue').default,ChartContainer: require('/build/apps/legacy/components/Reports/ChartContainer.vue').default})
